module.exports = __webpack_public_path__ + "img/banner.7ab3f4c0.png";